<!-- Request Renewal Modal-->
<div bsModal #upgradeSubscriptionModal="bs-modal" class="modal fade center-modal" id="requesrRenewalModal" tabindex="-1"
  data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content rounded-10 bg-popup box-shadow-popup border-all">
      <div class="modal-header justify-content-center align-items-center py-30">
        <img src="https://cdn.trovve.com/vfapp/images/icon-vf-bot.svg" class="mr-20" height="36px">
        <span class="f-size-20 font-weight-700">You'll hear back from us within 24 hours.</span>
      </div>
      <button type="button" class="close" (click)="closeUpgradeModal()">
        <span aria-hidden="true">&times;</span>
      </button>
      <form #upgradeForm="ngForm" novalidate (ngSubmit)="save()" class="overflow-auto">
        <div class="modal-body pt-20 px-30 py-5">
          <div class="request-renewal-form-wrapper">
            <div class="form-group mb-30">
              <label class="f-size-14 mb-10">Subject</label>
              <input type="text" class="form-control" value="Renew Subscription" readonly>
            </div>
            <div class="form-group mb-30">
              <label class="f-size-14 mb-3">1. Would you like to pay quarterly anor annually?</label>
              <div>
                <div class="custom-control custom-radio custom-radio-success custom-control-inline">
                  <input class="custom-control-input" type="radio" name="plan-span" id="plan-span-annual"
                    value="Annually (20% Discount)" [(ngModel)]="renewSub.subscriptionType">
                  <label class="custom-control-label text-capitalize f-size-14 text-vf-dark"
                    for="plan-span-annual">Annually (20% Discount)</label>
                </div>
                <div class="custom-control custom-radio custom-radio-success custom-control-inline mr-0">
                  <input class="custom-control-input" type="radio" name="plan-span" id="plan-span-quarterly"
                    value="Quarterly" [(ngModel)]="renewSub.subscriptionType">
                  <label class="custom-control-label text-capitalize f-size-14 text-vf-dark"
                    for="plan-span-quarterly">Quarterly</label>
                </div>
              </div>
            </div>
            <div class="form-group mb-30">
              <label class="f-size-14 mb-10">2. How many users do you have? *</label>
              <input type="number" name="nolicense" class="form-control" required min="{{licenseUsers}}"
                (blur)="validateMinUsers()" (keypress)="keyPressValidateUsers()" [(ngModel)]="renewSub.licenseUsers">
            </div>
            <div class="form-group">
              <label class="f-size-14 mb-10">2. Do you have any additional questions?</label>
              <textarea class="form-control" rows="3" name="addQues" [(ngModel)]="renewSub.additionalQuestions"
                data-gramm="false" data-gramm_editor="false" data-enable-grammarly="false"></textarea>
            </div>
          </div>
        </div>
      </form>
      <div class="modal-footer text-center mb-30">
        <div class="row">
          <div class="col-4 offset-4">
            <button type="submit" class="btn btn-black rounded-12 hover-shadow py-10  btn-block" (click)="save()"
              [disabled]="!upgradeForm.form.valid" [buttonBusy]="saving" [busyText]="l('SavingWithThreeDot')"><i
                class="fa fa-save"></i>
              <span>Submit</span></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>